<template>
  <div class="adminPasswordBox">
    <Form ref="formCustom" :label-width="105" :model="formCustom" :rules="passwordRules">
      <FormItem label="重置密码" prop="password">
        <Input v-model="formCustom.password" :maxlength="50" clearable password placeholder="请输入"
               style="width: 240px" type="password"></Input></FormItem>
      <FormItem label="确认密码" prop="confirmPassword">
        <Input v-model="formCustom.confirmPassword" :maxlength="50" clearable password placeholder="请输入"
               style="width: 240px" type="password"></Input>
      </FormItem>
    </Form>
    <p class="passwordMsg">提示：密码需要包含大写字母、小写字母、数字这三类字符，长度6-20个字符。</p>
    <div class="footerButton">
      <Button type="default" @click="handleBack('add')">返回</Button>
      <Button :loading="passwordLoading" style="margin-left: 10px" type="primary" @click="handleCommit('formCustom')">
        <span v-if="!passwordLoading">提交</span>
        <span v-else>提交中</span>
      </Button>
    </div>
  </div>
</template>

<script>
import {adminPassword} from '@/api/authority'

export default {
  name: 'adminPassword',
  data() {
    return {
      adminId: '', // 获取重置密码的Id
      passwordLoading: false,
      formCustom: {
        password: '',
        confirmPassword: ''
      },
      passwordRules: {
        password: [{required: true, message: '重置密码不能为空', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,20}$/
              if (reg.test(value)) {
                callback()
              } else {
                callback(new Error('英文大小写、数字组合，6-20字符'))
              }
            },
            trigger: 'blur'
          }
        ],
        confirmPassword: [{required: true, message: '确认密码不能为空', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请再次输入密码'))
              } else if (value !== this.formCustom.password) {
                callback(new Error('两次输入密码不一致'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {
    this.adminId = this.$route.query.adminId
  },
  methods: {
    // 返回
    handleBack() {
      this.$router.push(
        {
          path: '/authority/admin',
          query: {
            current: this.$route.query.current,
            size: this.$route.query.size,
            nikeName: this.$route.query.nikeName,
            adminCode: this.$route.query.adminCode,
            status: this.$route.query.status
          }
        }
      )
    },
    // 提交
    handleCommit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.passwordLoading = true
          adminPassword({
            adminId: this.adminId,
            password: this.formCustom.password
          }).then((response) => {
            if (response.data.success === false) {
              this.$Message.error(response.data.msg)
              this.passwordLoading = false
            } else {
              this.$Message.success(response.data.msg)
              this.passwordLoading = false
              this.$router.push({name: 'admin'})
            }
          }).catch(() => {
            this.passwordLoading = false
          })
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
.adminPasswordBox {
  .passwordMsg {
    /*  重置密码提示 */
    font-size: 0.8rem;
    color: #807a7a;
  }
}
</style>
